(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function () {
    // ---- Delete button (moved from cart-product-card.liquid) ----
    // Dispatches quantity -> 0 THROUGH the existing quantity-selector /
    // cart-items-component pipeline, so removal gets the same section
    // morph as +/-, keeping price, free-shipping bar, and confetti tier
    // in sync with no separate network call.
    if (!window.__cartCardDeleteListenerAttached) {
      window.__cartCardDeleteListenerAttached = true;

      document.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (!removeBtn) return;

        var card = removeBtn.closest('[data-cart-card]');
        if (!card) return;

        var selector = card.querySelector('cart-quantity-selector-component');
        if (!selector || typeof selector.setValue !== 'function' || typeof selector.onQuantityChange !== 'function') {
          return;
        }

        selector.setValue('0');
        selector.onQuantityChange();
      });
    }

    // ---- Free-shipping confetti (moved from cart-free-shipping-bar.liquid) ----
    // This setup code runs exactly once, ever. Cart re-renders go through
    // morphSection() (DOM patched in place), which does not re-execute
    // existing <script>/{% javascript %} content, so the actual
    // reactivity lives in a persistent MutationObserver below, not in
    // code that only runs at initial parse time.
    if (!window.__cartProgressConfettiInit) {
      window.__cartProgressConfettiInit = true;

      var STORAGE_KEY = 'cartProgressTier';
      var confettiColors = ['#0a6055', '#12836f', '#e0b84d', '#e07a5f', '#3d9a8b', '#f2cc8f', '#c94f4f'];
      var shapeVariants = ['rect', 'strip', 'triangle', 'irregular'];

      var randomBetween = function (min, max) {
        return min + Math.random() * (max - min);
      };

      var prefersReducedMotion = function () {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      };

      // Finds the cart drawer/cart page wrapper so confetti stays
      // visually bounded to the cart area instead of the whole screen.
      var getConfettiHost = function () {
        return (
          document.querySelector('cart-drawer-component') ||
          document.querySelector('.cart-drawer') ||
          document.querySelector('.cart-items__wrapper') ||
          document.body
        );
      };

      // ---- canvas-confetti (real library, loaded from esm.sh) ----
      // IMPORTANT CAVEAT: Shopify enforces a Content Security Policy
      // that restricts which external domains scripts can load from.
      // esm.sh is very likely NOT on that allowlist, meaning this
      // import can fail purely due to CSP, not a code bug. Rather than
      // risk breaking confetti entirely if that happens, this loads
      // once, caches the result (success or failure) on window, and
      // silently falls back to the existing hand-built confetti further
      // below if the import doesn't succeed. If you want the library
      // guaranteed to work regardless of CSP, download it and add it as
      // a real theme asset file instead of importing from an external
      // CDN — that's the standard, CSP-safe way to add a library.
var loadConfettiLib = function () {
  // Loaded as a first-party theme asset now (see the <script> tag added
  // in the markup above), not imported from an external CDN — this is
  // what actually fixes the CSP block. The library attaches itself to
  // `window.confetti` once that asset script has loaded.
  if (window.confetti) return Promise.resolve(window.confetti);

  // The asset tag isn't deferred, so by the time this script block runs
  // it should already be loaded — but poll briefly just in case load
  // order ever shifts, instead of assuming it's permanently missing.
  return new Promise(function (resolve) {
    var attempts = 0;
    var check = function () {
      if (window.confetti) {
        resolve(window.confetti);
        return;
      }
      attempts++;
      if (attempts > 20) {
        console.warn('canvas-confetti asset did not load in time — using built-in confetti instead.');
        resolve(null);
        return;
      }
      setTimeout(check, 100);
    };
    check();
  });
};

      // Fires the real canvas-confetti library, but on a canvas sized
      // and positioned to exactly the cart's bounding rect (not a
      // full-page canvas, which is the library's default) — this is
      // what keeps it bounded to the cart UI instead of covering the
      // whole page, per request.
      var fireLibConfetti = function (confettiFn) {
        var host = getConfettiHost();
        var rect = host.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;

        var canvas = document.createElement('canvas');
        canvas.width = rect.width;
        canvas.height = rect.height;
        canvas.style.position = 'fixed';
        canvas.style.left = rect.left + 'px';
        canvas.style.top = rect.top + 'px';
        canvas.style.width = rect.width + 'px';
        canvas.style.height = rect.height + 'px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = '1000';
        document.body.appendChild(canvas);

        var myConfetti = confettiFn.create(canvas, { resize: false, useWorker: true });

        myConfetti({
          particleCount: 120,
          spread: 100,
          startVelocity: 32,
          gravity: 1,
          ticks: 220,
          origin: { x: 0.5, y: 0.05 },
          colors: confettiColors,
        });

        setTimeout(function () {
          myConfetti.reset();
          if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        }, 3200);
      };

      var triggerConfetti = function () {
        if (prefersReducedMotion()) return;

        loadConfettiLib().then(function (confettiFn) {
          if (confettiFn) {
            fireLibConfetti(confettiFn);
          } else {
            spawnConfetti();
          }
        });
      };

      // Declared before spawnConfetti so spawnConfetti can pause it —
      // assigned further down once created. Confetti appends/removes
      // ~50 elements to document.body, and the observer below also
      // watches document.body's childList, so without pausing it here
      // every confetti piece insertion/removal would re-trigger the
      // observer callback reacting to its own DOM churn. This keeps
      // that self-triggering loop from ever happening.
      var tierObserver;

      // Scopes the tier-change observer to the cart section instead of
      // the entire document. Watching document.body meant ANY mutation
      // anywhere on the page (countdown timers, chat widgets, other
      // scripts, etc.) re-triggered this callback — under enough
      // mutation frequency elsewhere on the page, that alone can
      // saturate the main thread badly enough to look like a frozen
      // tab. IMPORTANT: no document.body fallback here — if
      // .cart-items__wrapper genuinely isn't found at call time, we
      // skip observing entirely rather than ever risk falling back to
      // watching the whole document (which is exactly the bug this was
      // meant to fix in the first place). Losing the confetti-on-tier-
      // change feature on some edge-case page is a far smaller cost
      // than a potential site-wide freeze.
      var getTierObserveRoot = function () {
        return document.querySelector('.cart-items__wrapper');
      };

      var spawnConfetti = function () {
        if (prefersReducedMotion()) return;

        var host = getConfettiHost();
        var rect = host.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;

        if (tierObserver) tierObserver.disconnect();

        var overlay = document.createElement('div');
        overlay.className = 'cart-progress-confetti-overlay';
        overlay.style.left = rect.left + 'px';
        overlay.style.top = rect.top + 'px';
        overlay.style.width = rect.width + 'px';
        overlay.style.height = rect.height + 'px';
        document.body.appendChild(overlay);

        var pieceCount = 46;
        var maxDuration = 0;
        var fallSpan = Math.max(rect.height * 0.55, 120);

        for (var i = 0; i < pieceCount; i++) {
          var piece = document.createElement('span');
          var shape = shapeVariants[Math.floor(Math.random() * shapeVariants.length)];
          var color = confettiColors[Math.floor(Math.random() * confettiColors.length)];

          piece.className = 'cart-progress-confetti-piece cart-progress-confetti-piece--' + shape;
          piece.style.left = randomBetween(0, 100) + '%';

          var width, height;
          if (shape === 'strip') {
            width = randomBetween(2, 4);
            height = randomBetween(12, 18);
          } else if (shape === 'triangle') {
            var triSize = randomBetween(6, 9);
            piece.style.borderLeft = (triSize / 2) + 'px solid transparent';
            piece.style.borderRight = (triSize / 2) + 'px solid transparent';
            piece.style.borderBottom = triSize + 'px solid ' + color;
          } else if (shape === 'irregular') {
            width = randomBetween(6, 9);
            height = randomBetween(6, 9);
          } else {
            width = randomBetween(5, 8);
            height = randomBetween(7, 11);
          }

          if (shape !== 'triangle') {
            piece.style.width = width + 'px';
            piece.style.height = height + 'px';
            piece.style.background = color;
          }

          var dx = randomBetween(-40, 40);
          var dy = randomBetween(fallSpan * 0.7, fallSpan);
          var rot = randomBetween(200, 620) * (Math.random() < 0.5 ? -1 : 1);
          var duration = randomBetween(1.3, 2.4);
          var delay = randomBetween(0, 0.4);

          piece.style.setProperty('--cp-dx', dx + 'px');
          piece.style.setProperty('--cp-dy', dy + 'px');
          piece.style.setProperty('--cp-rot', rot + 'deg');
          piece.style.animationDuration = duration + 's';
          piece.style.animationDelay = delay + 's';

          overlay.appendChild(piece);
          maxDuration = Math.max(maxDuration, duration + delay);
        }

        // Resume watching once this synchronous burst of insertions is
        // done — the observer's own callback re-reads the live tier
        // attribute anyway, so it doesn't matter that it missed these.
        var resumeRoot = getTierObserveRoot();
        if (tierObserver && resumeRoot) {
          tierObserver.observe(resumeRoot, {
            attributes: true,
            attributeFilter: ['data-current-tier'],
            subtree: true,
            childList: true,
          });
        }

        setTimeout(function () {
          if (overlay && overlay.parentNode) {
            if (tierObserver) tierObserver.disconnect();
            overlay.parentNode.removeChild(overlay);
            var cleanupRoot = getTierObserveRoot();
            if (tierObserver && cleanupRoot) {
              tierObserver.observe(cleanupRoot, {
                attributes: true,
                attributeFilter: ['data-current-tier'],
                subtree: true,
                childList: true,
              });
            }
          }
        }, (maxDuration + 0.3) * 1000);
      };

      var checkTierChange = function (progressEl) {
        var tier = parseInt(progressEl.getAttribute('data-current-tier'), 10) || 0;
        var storedRaw = sessionStorage.getItem(STORAGE_KEY);

        if (storedRaw === null) {
          sessionStorage.setItem(STORAGE_KEY, tier);
          return;
        }

        var storedTier = parseInt(storedRaw, 10);

        if (tier > storedTier) {
          triggerConfetti();
        }

        if (tier !== storedTier) {
          sessionStorage.setItem(STORAGE_KEY, tier);
        }
      };

      var initialEl = document.querySelector('.cart-progress[data-current-tier]');
      if (initialEl) checkTierChange(initialEl);

      tierObserver = new MutationObserver(function () {
        var el = document.querySelector('.cart-progress[data-current-tier]');
        if (el) checkTierChange(el);
      });

      // Attach to .cart-items__wrapper once it exists. It's rendered
      // unconditionally by this same file, so it should already be
      // present by the time this module script runs — but if for any
      // reason it isn't yet, retry a few times on a short timer rather
      // than ever falling back to observing document.body.
      var attachTierObserver = function (attemptsLeft) {
        var root = getTierObserveRoot();
        if (root) {
          tierObserver.observe(root, {
            attributes: true,
            attributeFilter: ['data-current-tier'],
            subtree: true,
            childList: true,
          });
          return;
        }
        if (attemptsLeft > 0) {
          setTimeout(function () {
            attachTierObserver(attemptsLeft - 1);
          }, 200);
        }
      };

      attachTierObserver(10);
    }
  })();


  (function () {
    // ---- Coupon panel (merged from cart-coupons.liquid + cart-coupons-panel.liquid) ----
    // Both "View Coupons" and "Enter a coupon code" rows are triggers
    // into this ONE panel now (data-open-coupon-panel); the row that
    // used to have its own separate input/submit no longer does — it
    // just opens this panel and optionally focuses its input via
    // data-focus-coupon-input.
    //
    // IMPORTANT: every listener here is registered on `document`
    // UNCONDITIONALLY, and looks up #couponPanel (and anything inside
    // it) FRESH, inside the handler, every time it fires — never cached
    // from setup time. The panel only exists in the DOM once the cart
    // has items (cart-coupons-panel.liquid only renders in that
    // branch), so on a page that first loads with an empty cart, a
    // one-time `var panel = document.getElementById('couponPanel')`
    // at setup would be null — and since this whole IIFE is guarded to
    // run only once ever, any listeners gated behind "if (panel)" would
    // never get attached, even after the cart became non-empty and the
    // panel actually appeared. That was the exact bug: "View Coupons"
    // did nothing after the first add-to-cart. This fresh-lookup-per-
    // event approach is the same safe pattern already used for the
    // delete button above.
    if (!window.__couponPanelInit) {
      window.__couponPanelInit = true;

      // Applies (or, with an empty string, clears) a discount code via
      // Shopify's native /cart/update.js "discount" parameter — this is
      // a documented, stable part of the Ajax Cart API, not something
      // specific to this theme. Requesting `sections` in the SAME POST
      // body (matching the exact pattern already used for quantity
      // updates elsewhere in this file) returns freshly-rendered HTML
      // for this cart section in one round trip, which we use to swap
      // in the updated cart contents — no page navigation, no reload,
      // stays inside the cart the whole time.
      var getCartSectionId = function () {
        var host = document.querySelector('cart-items-component[data-section-id]');
        return host ? host.getAttribute('data-section-id') : null;
      };

      var swapInFreshSectionHtml = function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshItems = doc.querySelector('.cart-items__wrapper');
        var liveItems = document.querySelector('.cart-items__wrapper');
        if (freshItems && liveItems) {
          liveItems.innerHTML = freshItems.innerHTML;
        }

        var freshSummary = doc.querySelector('.cart-drawer__summary');
        var liveSummary = document.querySelector('.cart-drawer__summary');
        if (freshSummary && liveSummary) {
          liveSummary.innerHTML = freshSummary.innerHTML;
        }
      };

      var updateDiscount = function (discountValue) {
        var sectionId = getCartSectionId();
        var body = { discount: discountValue };
        if (sectionId) {
          body.sections = sectionId;
          body.sections_url = window.location.pathname;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (sectionId && data.sections && data.sections[sectionId]) {
              swapInFreshSectionHtml(data.sections[sectionId]);
            }
            return data;
          });
      };

      // Fixes: a native swipe-back gesture (not a link click) skipped
      // straight past this panel's own close logic and navigated the
      // whole page away, because the panel wasn't registered in browser
      // history at all — as far as the browser was concerned, "back"
      // meant "go to whatever page was open before this one," full stop.
      // Pushing a history entry when the panel opens means the first
      // back/swipe-back only pops THAT entry (same document, no
      // navigation), which we catch via popstate and use to close the
      // panel instead. A second back gesture (panel already closed)
      // behaves normally. This only covers the panel built in this
      // file — the cart DRAWER itself is a separate component
      // (cart-drawer.js) outside what's in these files, and would need
      // the same technique added there to fix the drawer's own version
      // of this issue.
      var couponPanelHistoryPushed = false;

      var pushCouponPanelHistoryState = function () {
        if (couponPanelHistoryPushed) return;
        couponPanelHistoryPushed = true;
        history.pushState({ couponPanelOpen: true }, '', window.location.href);
      };

      var popCouponPanelHistoryState = function () {
        if (!couponPanelHistoryPushed) return;
        couponPanelHistoryPushed = false;
        history.back();
      };

      window.addEventListener('popstate', function () {
        if (!couponPanelHistoryPushed) return;
        couponPanelHistoryPushed = false;

        var openPanelEl = document.getElementById('couponPanel');
        if (openPanelEl && openPanelEl.classList.contains('is-open')) {
          openPanelEl.classList.remove('is-open');
          document.body.classList.remove('coupon-panel-open');
          setTimeout(function () {
            openPanelEl.hidden = true;
          }, 250);
        }
      });

      var openPanel = function (panel, focusInput) {
        pushCouponPanelHistoryState();
        panel.hidden = false;
        document.body.classList.add('coupon-panel-open');
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
          if (focusInput) {
            var input = panel.querySelector('.coupon-panel__input');
            if (input) {
              setTimeout(function () {
                input.focus();
              }, 300);
            }
          }
        });
      };

      var closePanel = function (panel) {
        panel.classList.remove('is-open');
        document.body.classList.remove('coupon-panel-open');
        popCouponPanelHistoryState();
        setTimeout(function () {
          panel.hidden = true;
        }, 250);
      };

      var fallbackCopy = function (text, onDone) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          if (onDone) onDone();
        } catch (err) {
          console.error('Copy failed:', err);
        }
        document.body.removeChild(textarea);
      };

      var copyCode = function (code, buttonEl) {
        var trimmed = (code || '').trim();
        if (!trimmed) return;

        var showCopied = function () {
          if (!buttonEl) return;
          var original = buttonEl.textContent;
          buttonEl.textContent = 'Copied!';
          buttonEl.disabled = true;
          setTimeout(function () {
            buttonEl.textContent = original;
            buttonEl.disabled = false;
          }, 1400);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(trimmed).then(showCopied).catch(function () {
            fallbackCopy(trimmed, showCopied);
          });
        } else {
          fallbackCopy(trimmed, showCopied);
        }
      };

      document.addEventListener('click', function (e) {
        var openTrigger = e.target.closest('[data-open-coupon-panel]');
        if (openTrigger) {
          var panelToOpen = document.getElementById('couponPanel');
          if (panelToOpen) {
            openPanel(panelToOpen, openTrigger.hasAttribute('data-focus-coupon-input'));
          }
          return;
        }

        var backBtn = e.target.closest('#couponPanelBack');
        if (backBtn) {
          var panelToClose = document.getElementById('couponPanel');
          if (panelToClose) closePanel(panelToClose);
          return;
        }

        var copyBtn = e.target.closest('[data-coupon-code]');
        if (copyBtn) {
          copyCode(copyBtn.getAttribute('data-coupon-code'), copyBtn);
          return;
        }

        var moreBtn = e.target.closest('[data-coupon-more]');
        if (moreBtn) {
          var card = moreBtn.closest('.coupon-card');
          var terms = card ? card.querySelector('.coupon-card__terms') : null;
          if (terms) {
            terms.hidden = !terms.hidden;
            moreBtn.textContent = terms.hidden ? 'View more' : 'View less';
          }
          return;
        }

        var tab = e.target.closest('[data-coupon-tab]');
        if (tab) {
          var tabPanel = document.getElementById('couponPanel');
          if (!tabPanel) return;

          tabPanel.querySelectorAll('[data-coupon-tab]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          tab.classList.add('is-active');

          var filter = tab.getAttribute('data-coupon-tab');
          tabPanel.querySelectorAll('.coupon-card').forEach(function (c) {
            c.hidden = filter === 'all' ? false : c.getAttribute('data-coupon-status') !== filter;
          });
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openPanelEl = document.getElementById('couponPanel');
        if (openPanelEl && openPanelEl.classList.contains('is-open')) {
          closePanel(openPanelEl);
        }
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-coupon-form]');
        if (!form) return;

        var panel = document.getElementById('couponPanel');
        if (!panel || !panel.contains(form)) return;

        e.preventDefault();
        var input = form.querySelector('.coupon-panel__input');
        var submitBtn = form.querySelector('.coupon-panel__input-submit');
        var code = input ? input.value.trim() : '';
        if (!code) return;

        if (submitBtn) submitBtn.disabled = true;

        updateDiscount(code).then(function () {
          // Close the panel and return to the main cart view, per
          // request: applying a coupon should keep you inside the cart,
          // not send you elsewhere.
          var reopenedPanel = document.getElementById('couponPanel');
          if (reopenedPanel) closePanel(reopenedPanel);
        }).catch(function (err) {
          console.error('Coupon apply failed:', err);
        }).finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
      });

      document.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-remove-discount]');
        if (!removeBtn) return;

        removeBtn.disabled = true;
        updateDiscount('').catch(function (err) {
          console.error('Coupon remove failed:', err);
        }).finally(function () {
          removeBtn.disabled = false;
        });
      });
    }
  })();


  (function () {
    // ---- Cart summary expand/collapse (moved from cart-summary.liquid) ----
    if (!window.__cartSummaryToggleInit) {
      window.__cartSummaryToggleInit = true;

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cart-summary-toggle]');
        if (!toggle) return;

        var targetId = toggle.getAttribute('aria-controls');
        var panel = targetId ? document.getElementById(targetId) : null;
        if (!panel) return;

        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.hidden = isExpanded;
      });
    }
  })();


  (function () {
    // ---- Share Cart button ----
    // Uses the Web Share API (native OS share sheet — WhatsApp,
    // Messages, Email, etc.) where available, which covers essentially
    // all mobile browsers. Falls back to copying the cart link to the
    // clipboard on browsers without it (mostly desktop). The URL shared
    // is a Shopify cart permalink (built server-side in this file's
    // {% liquid %} block) — opening it adds the exact same line items
    // to whoever opens it, not just a generic storefront link.
    if (!window.__cartShareInit) {
      window.__cartShareInit = true;

      var fallbackCopy = function (text, onDone) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          if (onDone) onDone();
        } catch (err) {
          console.error('Copy failed:', err);
        }
        document.body.removeChild(textarea);
      };

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-share]');
        if (!btn) return;

        var shareData = {
          title: btn.getAttribute('data-share-title') || document.title,
          text: btn.getAttribute('data-share-text') || '',
          url: btn.getAttribute('data-share-url') || window.location.href,
        };

        if (navigator.share) {
          navigator.share(shareData).catch(function (err) {
            // AbortError just means the person closed the native share
            // sheet without picking anything — not a real error.
            if (err && err.name !== 'AbortError') {
              console.error('Share failed:', err);
            }
          });
          return;
        }

        var label = btn.querySelector('.cart-share-button__label');
        var showCopied = function () {
          if (!label) return;
          var original = label.textContent;
          label.textContent = 'Link copied!';
          setTimeout(function () {
            label.textContent = original;
          }, 1600);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareData.url).then(showCopied).catch(function () {
            fallbackCopy(shareData.url, showCopied);
          });
        } else {
          fallbackCopy(shareData.url, showCopied);
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
